import type React from 'react';
import './styles.scss';

export const Head = ({ children }: { children?: React.ReactNode }) => (
	<div className="head">{children}</div>
);
